export const manifest = {
  screens: {
    scr_8hhe5u: { name: "Time with Solventum pays back", route: "/", state: {"slideIndex":0}, position: {"x":2960,"y":220} },
    scr_prb002: { name: "HCP attention is expensive", route: "/", state: {"slideIndex":1}, position: {"x":160,"y":220} },
    scr_prm003: { name: "Give us a little time", route: "/", state: {"slideIndex":2}, position: {"x":1560,"y":220} },
    scr_fmt004: { name: "The countdown becomes the signal", route: "/", state: {"slideIndex":3}, position: {"x":4360,"y":220} },
    scr_prf005: { name: "Same contract. Different reward", route: "/", state: {"slideIndex":4}, position: {"x":5760,"y":220} },
    scr_amb006: { name: "From campaigns to a Solventum habit", route: "/", state: {"slideIndex":5}, position: {"x":7160,"y":220} },
    scr_opm007: { name: "Now we make it real", route: "/", state: {"slideIndex":6}, position: {"x":5760,"y":2200} },
    scr_prt008: { name: "Where does Solventum have something worth 30 seconds?", route: "/", state: {"slideIndex":7}, position: {"x":2960,"y":2200} },
    scr_stm009: { name: "Don’t tell experts what they already know", route: "/", state: {"slideIndex":8}, position: {"x":160,"y":2200} },
    scr_rhy010: { name: "A year of small investments", route: "/", state: {"slideIndex":9}, position: {"x":4360,"y":2200} },
    scr_eco011: { name: "The campaign is not the channel", route: "/", state: {"slideIndex":10}, position: {"x":1560,"y":2200} },
    scr_srt012: { name: "What do we need to make this happen?", route: "/", state: {"slideIndex":11}, position: {"x":7160,"y":2200} },
  },
  sections: {
    sec_22akog: { name: "Solventum value proposition", x: 0, y: 0, width: 8520, height: 1180 },
    sec_uk1zq0: { name: "Strategy & execution", x: 0, y: 1980, width: 8520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_22akog", children: [
      { kind: "screen", id: "scr_prb002" },
      { kind: "screen", id: "scr_prm003" },
      { kind: "screen", id: "scr_8hhe5u" },
      { kind: "screen", id: "scr_fmt004" },
      { kind: "screen", id: "scr_prf005" },
      { kind: "screen", id: "scr_amb006" },
    ] },
    { kind: "section", id: "sec_uk1zq0", children: [
      { kind: "screen", id: "scr_stm009" },
      { kind: "screen", id: "scr_eco011" },
      { kind: "screen", id: "scr_prt008" },
      { kind: "screen", id: "scr_rhy010" },
      { kind: "screen", id: "scr_opm007" },
      { kind: "screen", id: "scr_srt012" },
    ] },
  ],
}
